// pages/ForgotPassword/index.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { authService } from "../../services/auth.service";
import { Button } from "../../styles/components";
import {
	ForgotPasswordWrapper,
	ForgotPasswordCard,
	Form,
	FormGroup,
	Label,
	Input,
	ErrorMessage,
	SuccessMessage,
	BackToLogin,
} from "./styles";

const ForgotPassword = () => {
	const [email, setEmail] = useState("");
	const [error, setError] = useState("");
	const [success, setSuccess] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setSuccess(false);
		setLoading(true);

		try {
			await authService.resetPassword(email);
			setSuccess(true);
			toast.success("Password reset email sent!", {
				style: { padding: "1rem" },
			});
		} catch (err) {
			console.error("Password reset error:", err);
			setError(
				"Failed to send password reset email. Please verify your email address."
			);
			toast.error("Failed to send reset email", {
				style: { padding: "1rem" },
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<ForgotPasswordWrapper>
			<ForgotPasswordCard
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.6 }}
			>
				<h1>Reset Password</h1>
				<p>Enter your email address to receive a password reset link.</p>

				{success ? (
					<SuccessMessage>
						<h3>Email Sent!</h3>
						<p>Check your email for instructions to reset your password.</p>
						<BackToLogin>
							<Link to="/login">Return to Login</Link>
						</BackToLogin>
					</SuccessMessage>
				) : (
					<Form onSubmit={handleSubmit}>
						<FormGroup>
							<Label htmlFor="email">Email Address</Label>
							<Input
								type="email"
								id="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
								placeholder="Enter your email"
								autoComplete="email"
							/>
						</FormGroup>

						{error && <ErrorMessage>{error}</ErrorMessage>}

						<Button type="submit" disabled={loading || !email} size="large">
							{loading ? "Sending..." : "Send Reset Link"}
						</Button>

						<BackToLogin>
							<Link to="/login">Back to Login</Link>
						</BackToLogin>
					</Form>
				)}
			</ForgotPasswordCard>
		</ForgotPasswordWrapper>
	);
};

export default ForgotPassword;
